export const FETCH_PURCHASE_REQUEST = "FETCH_PURCHASE_REQUEST";
export const FETCH_PURCHASE_FAILURE = "FETCH_PURCHASE_FAILURE";
export const FETCH_PURCHASE_SUCCESS = "FETCH_PURCHASE_SUCCESS";
export const FETCH_MORE_PURCHASE_SUCCESS = "FETCH_MORE_PURCHASE_SUCCESS";

export const FETCH_PURCHASE_CUSTOMERS_REQUEST = "FETCH_PURCHASE_CUSTOMERS_REQUEST";
export const FETCH_PURCHASE_CUSTOMERS_FAILURE = "FETCH_PURCHASE_CUSTOMERS_FAILURE";
export const FETCH_PURCHASE_CUSTOMERS_SUCCESS = "FETCH_PURCHASE_CUSTOMERS_SUCCESS";